import { render, staticRenderFns } from "./BAEventInvite.vue?vue&type=template&id=5593508f&"
import script from "./BAEventInvite.vue?vue&type=script&lang=ts&"
export * from "./BAEventInvite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports